// Modules
import { connect } from 'react-redux';
import Promise from 'bluebird';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { Page, PageHeader, PageContent, ActionSection } from 'components/page';
import { PrimaryButton } from 'components/widgets/buttons';
import { SortableTH } from 'components/content-containers/tables';
import { Table } from 'components/content-containers/tables/tables';
import { alerts } from 'modules/alerts/actions';
import { didQueryUpdate } from 'utils/filter-utils';
import Company from 'services/data/company';
import CompanyRow from 'components/models/company/company-row';
import Filters from 'modules/filters/filters';
import FlipMove from 'components/widgets/animation/flip-move';
import Pager from 'components/widgets/pager/pager';
import exportCSV from 'utils/export-csv';

import * as actions from './store/actions';


// Component
class Companies extends React.Component {
  static propTypes = {
    companies: PropTypes.array,
    fetching: PropTypes.bool,
    count: PropTypes.number,
    query: PropTypes.object,
    users: PropTypes.array,
    currentUser: PropTypes.object.isRequired
  };

  constructor() {
    super();

    this.search = this.search.bind(this);
    this.export = this.export.bind(this);

    this.filterConfig = {
      basic: ['search'],
      advanced: [
        ['search', 'team', 'primaryTech'],
        ['status', 'companyType']
      ],
      defaults: { status: ['Active'], companyType: ['Client', 'Contact'] }
    };
  }

  componentWillReceiveProps(nextProps) {
    if (didQueryUpdate(nextProps, this.props)) this.search(nextProps.query);
  }

  componentWillUnmount() {
    actions.set({ companies: [], count: null });
  }

  search(query) {
    actions.set({ fetching: true });
    const fullQuery = Company.formatQuery(query || this.props.query);

    return Promise.props({
      companies: Company.find(fullQuery),
      count: Company.count({ where: fullQuery.where })
    })
      .then((response) => {
        actions.set({ fetching: false, companies: response.companies, count: response.count });
      })
      .catch(alerts.catchError);
  }

  export() {
    const fullQuery = Company.formatQuery(this.props.query);
    delete fullQuery.limit;

    Company.find(fullQuery)
      .then((companies) => {
        const header = ['Name'];

        const data = _.map(companies, company => [
          _.get(company, 'name', '')
        ]);

        exportCSV(data, 'companies.csv', { header });
      })
      .catch(alerts.catchError);
  }

  render() {
    const { companies = [], count = 0, fetching } = this.props;

    const headerActions = (
      <div className="header-actions">
        <PrimaryButton onClick={this.export} disabled={_.isEmpty(companies)}>Export</PrimaryButton>
      </div>
    );

    return (
      <Page>
        <PageHeader title="Companies" actions={headerActions}>
          <ActionSection>
            <Filters config={this.filterConfig} />
          </ActionSection>
        </PageHeader>
        <PageContent
          fetching={fetching}
          emptyText="No companies, adjust your filters!"
          emptyTextIcon="svg/company.svg"
          showEmptyText={!fetching && _.isEmpty(companies)}
          className="companies"
        >
          <div className="companies-table">
            <Table>
              <thead>
                <tr>
                  <SortableTH className="collapse-width" sortField="name">Name</SortableTH>
                  <SortableTH className="collapse-width" sortField="team.order">Team</SortableTH>
                  <SortableTH className="collapse-width" sortField="primaryTech.poPrefix">Primary Tech</SortableTH>
                </tr>
              </thead>
              <FlipMove typeName="tbody" enterAnimation="fade" leaveAnimation="fade">
                {_.map(companies, (company) => <CompanyRow key={company.id} company={company} />)}
              </FlipMove>
            </Table>
          </div>
          <Pager count={count} />
        </PageContent>
      </Page>
    );
  }
}

// Exports
export default connect((state) => ({
  companies: state.companies.companies,
  fetching: state.companies.fetching,
  users: state.pageData.selectUsers,
  count: state.companies.count,
  query: state.location.query,
  currentUser: state.auth.currentUser
}))(Companies);



// WEBPACK FOOTER //
// ./app/routes/company/view-companies.js